import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { baseurl } from "../baseurl";
import login1 from "../assets/img/logo.webp";

function CustomerAuth() {
  const [isLogin, setIsLogin] = useState(true); // toggle between Login / Register
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Form fields
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
  });

  // Handle input change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Handle submit (Login or Register)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const endpoint = isLogin ? "customers/login" : "customers/register";

    console.log("%c📤 Sending data:", "color: orange;", form);

    try {
      const res = await axios.post(`${baseurl}${endpoint}`, form);

      console.log("%c✅ API Response:", "color: green;", res.data);

      const customer = res.data.data;

      // Store in localStorage
      localStorage.setItem("customer_id", customer.id);
      localStorage.setItem("customer_name", customer.name);
      localStorage.setItem("customer_email", customer.email);

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: isLogin ? "Login successful" : "Registration successful",
        showConfirmButton: false,
        timer: 2000,
        background: "#28a745",
        color: "#ffffff",
      });

      // Redirect
      setTimeout(() => {
        navigate("/dashboard");
      }, 1500);
    } catch (err) {
      console.error("%c❌ API Error:", "color: red;", err);

      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Something went wrong";

      setError(msg);

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: msg,
        showConfirmButton: false,
        timer: 2500,
        background: "red",
        color: "#ffffff",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-3 mx-lg-0">
      <div className="card my-5 col-xl-9 col-xxl-8 mx-auto rounded-4 overflow-hidden p-4">
        <div className="row g-4">
          {/* Left side - form */}
          <div className="col-lg-6 d-flex">
            <div className="card-body">
              {/* <img
                src="assets/images/logo1.png"
                className="mb-4"
                width="145"
                alt="Logo"
              /> */}
              <h4 className="fw-bold">
                {isLogin ? "Customer Login" : "Customer Register"}
              </h4>
              <p className="mb-0">
                {isLogin
                  ? "Login with your registered email and password"
                  : "Create a new customer account"}
              </p>

              <div className="form-body mt-4">
                <form className="row g-3" onSubmit={handleSubmit}>
                  {/* Name (only for register) */}
                  {!isLogin && (
                    <div className="col-12">
                      <label htmlFor="inputName" className="form-label">
                        Full Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputName"
                        name="name"
                        placeholder="Enter your name"
                        value={form.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  )}

                  {/* Email */}
                  <div className="col-12">
                    <label htmlFor="inputEmailAddress" className="form-label">
                      Email Address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="inputEmailAddress"
                      name="email"
                      placeholder="customer@example.com"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Password */}
                  <div className="col-12">
                    <label htmlFor="inputPassword" className="form-label">
                      Password
                    </label>
                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control border-end-0"
                        id="inputPassword"
                        name="password"
                        placeholder="Enter Password"
                        value={form.password}
                        onChange={handleChange}
                        required
                      />
                      <button
                        type="button"
                        className="input-group-text bg-transparent"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <i
                          className={
                            showPassword
                              ? "bi bi-eye-fill"
                              : "bi bi-eye-slash-fill"
                          }
                        ></i>
                      </button>
                    </div>
                  </div>

                  {/* Error message */}
                  {error && <div className="col-12 text-danger">{error}</div>}

                  {/* Submit */}
                  <div className="col-12">
                    <div className="d-grid">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading
                          ? isLogin
                            ? "Logging in..."
                            : "Registering..."
                          : isLogin
                          ? "Login"
                          : "Register"}
                      </button>
                    </div>
                  </div>
                </form>

                {/* Toggle link */}
                {/* <div className="text-center mt-3">
                  <button
                    className="btn btn-link text-decoration-none"
                    onClick={() => {
                      setIsLogin(!isLogin);
                      setError("");
                      setForm({ name: "", email: "", password: "" });
                    }}
                  >
                    {isLogin
                      ? "New user? Create an account"
                      : "Already registered? Login here"}
                  </button>
                </div> */}
              </div>
            </div>
          </div>

          {/* Right side - image */}
          <div className="col-lg-6 d-lg-flex d-none">
            <div className="p-3 rounded-4 w-100 d-flex align-items-center justify-content-center bg-light">
              <img src={login1} className="img-fluid" alt="Login illustration" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerAuth;
